export default __webpack_public_path__ + "static/media/apology.43fe7c7c.png";